export default {
  "slots": {
    "trigger": "text-base",
    "body": "text-base text-(--ui-text-muted)"
  }
}